(function ($, angular, Cookies, window) {
    'use strict';
    
    window.THF.Angular.JoinForm.directive('thfHospitalProductTable', ['ngDialog', 'ProductTableModel', function (ngDialog, ProductTableModel) {

        var link = function (scope, elem) {
            scope.openMoreInfoModal = function (clinicalCategory) {
                var document = window.document;
                
                var modal = document.createElement('div');
                modal.classList.add('modal');

                var modalOverlay = document.createElement('div');
                modalOverlay.classList.add('modal-overlay');
                modalOverlay.addEventListener('click', function (event) {
                    modal.remove();
                });

                var modalContent = document.createElement('div');
                modalContent.classList.add('modal-content');
                modalContent.style.position = 'fixed';
                modalContent.style.top = '50%';
                modalContent.style.left = '50%';
                modalContent.style.transform = 'translate(-50%, -50%)';

                // Modal Content
                var modalTitle = document.createElement('div');
                modalTitle.classList.add('modal-title');

                var modalHeading = document.createElement('div');
                modalHeading.classList.add('modal-heading');
                modalHeading.innerText = clinicalCategory.name;

                var modalBtnClose = document.createElement('div');
                modalBtnClose.classList.add('modal-btn-close');
                modalBtnClose.addEventListener('click', function (event) {
                    modal.remove();
                });
                modalBtnClose.innerHTML = `<svg class="icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/static/svg/sprite.svg#ui-not-applicable"></use></svg>`;

                modalTitle.appendChild(modalHeading);
                modalTitle.appendChild(modalBtnClose);

                var modalBody = document.createElement('div');
                modalBody.classList.add('modal-body');

                modalBody.innerHTML = clinicalCategory.description;


                modalContent.appendChild(modalTitle);
                modalContent.appendChild(modalBody);

                modal.appendChild(modalOverlay);
                modal.appendChild(modalContent);

                document.body.appendChild(modal);
            }

            scope.openHospitalProductModal = function (productId) {
                ngDialog.open({
                    template: 'modal-hospital-product',
                    className: 'ngdialog-theme-table',
                    controller: ['$scope', function ($scope) {
                        $scope.productId = productId;
                        $scope.product = null;
                        $scope.categorySectionOpen = {
                            '0': true
                        };
                        
                        $scope.openCategorySection = function(index) {
                            if(typeof $scope.categorySectionOpen[index] === 'undefined') {
                                $scope.categorySectionOpen[index] = true;
                            }
                            else {
                                $scope.categorySectionOpen[index] = !$scope.categorySectionOpen[index];    
                            }
                        }

                        ProductTableModel.hospitalProductTable(productId)
                            .then(function (result) {
                                $scope.product = result.data;
                            })
                            .catch(function (error) {
                                // console.log(error);
                            });

                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: scope
                });
            }
            
        };

        return {
            'restrict': 'E',
            'replace': true,
            'link': link,
            'scope': {
                'options': '=',
                'formState': '='
            },
            'templateUrl': function (elem, attr) {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/partials/hospital-product-table.html');
            }
        };
    }]);
})(jQuery, angular, Cookies, window);